import { Notifications } from "../notifications";
export class ChangePassword {
    constructor() {
        this.form = $("#change-password-panel form");
        this.password = $("#password");
        this.password2 = $("#password2");
        this.form.on("submit", (e) => this.onSubmit(e));
    }
    onSubmit(event) {
        try {
            this.checkEmpty();
            this.checkLength();
            this.checkEquals();
        }
        catch (error) {
            event.preventDefault();
            Notifications.error(error.message);
        }
    }
    checkEmpty() {
        if (!this.password.val()) {
            throw new Error(emptyPassword);
        }
    }
    checkLength() {
        const minLength = this.password.data("minLength");
        if (this.password.val().length < minLength) {
            throw new Error(minPassword);
        }
    }
    checkEquals() {
        if (this.password.val() !== this.password2.val()) {
            throw new Error(passwordMismatch);
        }
    }
}
